import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular/lazy';
//import { SplashScreen } from '@ionic-native/splash-screen/ngx';
//import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

//import { AmplifyUIAngularModule } from '@aws-amplify/ui-angular';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { TranslateModule, TranslateLoader} from '@ngx-translate/core';
import { TranslateHttpLoader} from '@ngx-translate/http-loader';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
//import { BnNgIdleService } from 'bn-ng-idle';
import { DirectiveModule } from './directives/directive.module';
import { PopoverModule } from './result//popover/popover.module';

import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { IonicStorageModule } from '@ionic/storage-angular';

@NgModule({ 
    declarations: [
        AppComponent,
    ],
    bootstrap: [AppComponent], 
    imports: [
        //AmplifyUIAngularModule,
        BrowserModule,
        IonicModule.forRoot({ animated: true, innerHTMLTemplatesEnabled: true }),
        AppRoutingModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        BrowserAnimationsModule,
        DirectiveModule,
        PopoverModule,
        IonicStorageModule.forRoot()
    ], 
    providers: [
        //StatusBar,
        //SplashScreen,
        //BnNgIdleService,
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimationsAsync(),
        providePrimeNG({
            theme: {
                preset: Aura
            }
        })
    ] 
})
export class AppModule {}

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
